// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KIT0","buttons":"styles_buttons__1UDDA"};